// extracted by mini-css-extract-plugin
export var border = "_1r-8";
export var brand = "_1r-t";
export var button = "_1r-l";
export var center = "_1r-a";
export var centered = "_1r-6";
export var closeButton = "_1r-c";
export var disabledWrapper = "_1r-m";
export var error = "_1r-p";
export var extraLarge = "_1r-4";
export var extraSmall = "_1r-1";
export var fill = "_1r-i";
export var footer = "_1r-h";
export var footerAction = "_1r-j";
export var footerButtons = "_1r-k";
export var header = "_1r-7";
export var headerWithClose = "_1r-d";
export var icon = "_1r-o";
export var info = "_1r-s";
export var inline = "_1r-9";
export var large = "_1r-3";
export var main = "_1r-e";
export var modal = "_1r-0";
export var nearFull = "_1r-5";
export var neutral = "_1r-u";
export var noPadding = "_1r-g";
export var none = "_1r-v";
export var scrollable = "_1r-f";
export var small = "_1r-2";
export var success = "_1r-r";
export var tight = "_1r-n";
export var titleIcon = "_1r-b";
export var warn = "_1r-q";